import { IContact } from "src/app/contact/models/contact";
import { IBase, IBaseSearchRequest } from "src/app/core/models/base";
import { IEmployee } from "src/app/employee/employee";
import { ISchedulerItem } from "src/app/scheduler/models/scheduler";
import { TimeSpan } from "src/app/shared/helpers/time-span";
import { ITimeEntry } from "src/app/time-tracking/models/time-entry";
import { IAssignmentService } from "./assignment-service";
import { IAssignmentType } from "./assignment-type";
import { IService } from "./service";

export interface IAssignment extends IBase {
    title: string,
    internalNumber?: string,
    description?: string,
    specialNote?: string,
    dueDate?: Date,
    createdOn: Date,
    client: IContact,
    executionLocation?: IContact | null,
    executionLocationId?: string | null,
    owner: IEmployee,
    executors?: IEmployee[],
    typeId?: string,
    type?: IAssignmentType,
    taskStatus: TaskStatues,
    schedulerItems: ISchedulerItem[],
    timeEntries: ITimeEntry[],
    assignmentServices: IAssignmentService[],
    defaultTimeTotal: TimeSpan,
    timeEntriesTotal: TimeSpan,
    totalTime: string
    totalTimeObj: TimeSpan
}

export interface IAssignmentInfo {
    title: string,
    customerName: string,
    id: string;
}

export interface ISearchAssignmentsRequest extends IBaseSearchRequest {
    hasNoSchedulerItems?: boolean,
    taskStatuses?: TaskStatues[],
    assignmentTypeIds?: string[],
    executorIds?: string[],
    includeUnassignedExecutors?: boolean
}

export const UNASSIGNED_SENTINEL = '__unassigned__';

export interface ICreateAssignmentRequest {
    title: string,
    internalNumber?: string,
    description?: string,
    specialNote?: string,
    dueDate?: Date,
    clientId: IContact,
    ownerId: IEmployee,
    typeId?: string,
    executionLocationId?: string | null,
    executorIds?: string[]
}

export interface IUpdateAssignmentRequest extends ICreateAssignmentRequest {
    id: string,
}

export enum TaskStatues {
    open = 10,
    inProgress = 20,
    review = 25,
    finished = 30
}